export default "__VITE_ASSET__BJslDsbQ__"